import { KpiType } from "../helpers/enum";
import { RenaultReportTasasCrm } from "./renault-statistics-dto";

export class RenaultKpiFilter {
  IdSection: number;
  Years: number[];
}

export class RenaultKpiTotalModel {
  Year: number;
  Model: RenaultKpiModel[];
}

export class RenaultKpiModel {
  IdKpi: number;
  IdBrand?: number;
  IdDistributor?: number;
  IdVnPlate?: number;
  IdPvGroup?: number;
  IdRegion?: number;
  SectionPv: string;
  PvGroupName: string;
  DistributorName: string;
  Month: number;
  Year: number;
  Data: number;
  DataString: string;
  IdRelation?: number;
}

export class KpiObjetivoRealizacionModel {
  Month: number;
  Year: number;
  Objetivo: number;
  Realizacion: number;
  PorcRealizacion: number;
  ObjetivoComparative: number;
  RealizacionComparative: number;
  PorcRealizacionComparative: number;
  RealizacionComparativeDiff: number;
  PorcRealizacionComparativeDiff: number;
  Top20Distributors: string[];
  Top20ComparativeDistributors: string[];
}

export class KpiRealizacionModel {
  Month: number;
  Year: number;
  Realizacion: number;
  RealizacionComparative: number;
  RealizacionComparativeDiff: number;
  Top20Distributors: string[];
  Top20ComparativeDistributors: string[];
  KpiName: string;
  Id?: number;
}

export class KpiRealizacionQuarterModel {
  Quarter: number;
  Year: number;
  Realizacion: number;
  RealizacionComparative: number;
  RealizacionComparativeDiff: number;
  KpiName: string;
}

export class KpiRealizacion2DataModel {
  Month: number;
  Year: number;
  Realizacion: number;
  Realizacion2: number;
  RealizacionComparative: number;
  Realizacion2Comparative: number;
  RealizacionComparativeDiff: number;
  Realizacion2ComparativeDiff: number;
  KpiName: string;
}

export class KpiRealizacionMonthModel {
  Month: number;
  Year: number;
  Realizacion: number;
  Top20Distributors: string[];
  KpiName: string;
}

export class RenaultKpiYearDaysRatioDTO {
  IdData: number;
  Year: number;
  Month: number;
  Days: number;
  TotalDays: number;
  Ratio: number;
}

export class RenaultKpiActividadTallerVisitsTotalModel {
  Year: number;
  Model: RenaultKpiActividadTallerVisitsModel[];
}

export class RenaultKpiActividadTallerVisitsModel {
  IdKpi: number;
  IdPvGroup: number;
  SectionPv: string;
  IdDistributor: number;
  DistributorName: string;
  IdPayment: number;
  IdWorkshop: number;
  IdBrand: number;
  VehicleAge: number;
  Month: number;
  Year: number;
  Visits: number;
}

export class RenaultKpiActividadTallerBillingHourTotalModel {
  Year: number;
  Model: RenaultKpiActividadTallerBillingHourModel[];
}

export class RenaultKpiActividadTallerBillingHourModel {
  IdKpi: number;
  IdPvGroup: number;
  SectionPv: string;
  IdDistributor: number;
  DistributorName: string;
  IdPayment: number;
  IdWorkshop: number;
  IdInvoiceType: number;
  IdBrand: number;
  VehicleAge: number;
  Month: number;
  Year: number;
  Billing: number;
  Hours: number;
}

export class RenaultKpiActividadTallerTfaTotalModel {
  Year: number;
  Model: RenaultKpiActividadTallerTfaModel[];
}

export class RenaultKpiActividadTallerTfaModel {
  IdKpi: number;
  IdPvGroup: number;
  SectionPV: string;
  IdWorkshop: number;
  IdBrand: number;
  VehicleAge: number;
  Month: number;
  Year: number;
  Contacts: number;
  IdRelation: number;
  Parque: number;
}

export class RenaultKpiExperienciaClienteBonusCalidadTotalModel {
  Year: number;
  Model: RenaultKpiExperienciaClienteBonusCalidadModel[];
}

export class RenaultKpiExperienciaClienteBonusCalidadModel {
  IdRegion?: number;
  IdPvGroup?: number;
  SectionPV: string;
  Quarter: number;
  Year: number;
  BonusName: string;
  BonusMax: number;
  BonusData: number;
  IdDistributor?: number;
}

export class KpiStackFilterModel {
  Id: number;
  Name: string;
  Checked?: boolean = false;
}

export class KpiStackGroupModel {
  Id: number;
  Name: string;
  IsTotal: boolean;
  Includes: number[];
  GreaterThan: number;
  ShowInDetail: boolean;
}

export class KpiStackGroupDataModel {
  IdFilter: number;
  IdStack: number;
  Stack: string;
  IsTotal: boolean;
  Month: number;
  Year: number;
  Realizacion: number;
  RealizacionPorc: number;
  RealizacionComparative: number;
  RealizacionComparativePorc: number;
  RealizacionComparativeDiff: number;
  RealizacionComparativeDiffPorc: number;
  Top20Distributors: string[] = [];
  Top20ComparativeDistributors: string[] = [];
  Media: number = 0;
  MediaComparative: number = 0;
}

export class KpiBonusCalidadModel {
  Quarter: number;
  Year: number;
  CnBonus: number;
  BonusMaximo: number;
  BonusMaximoPorc: number;
  BonusObtenido: number;
  BonusObtenidoPorc: number;
  BonusPerdido: number;
  BonusPerdidoPorc: number;
  BonusData : KpiBonusCalidadDataModel[];
}

export class KpiBonusCalidadDataModel {
  BonusName: string;
  BonusMaximo: number;
  BonusMaximoPorc: number;
  BonusObtenido: number;
  BonusObtenidoPorc: number;
}

export class KpiStack2DataGroupDataModel {
  IdFilter: number;
  IdStack: number;
  Stack: string;
  IsTotal: boolean;
  Month: number;
  Year: number;
  Objetivo: number;
  Realizacion: number;
  PorcRealizacion: number;
  ObjetivoComparative: number;
  ObjetivoComparativeDiff: number;
  RealizacionComparative: number;
  PorcRealizacionComparative: number;
  RealizacionComparativeDiff: number;
  PorcRealizacionComparativeDiff: number;
}

export class KpiCrmModel {
  Month: number;
  Data: number;
}

export class LocalCampaignStatisticsKpiTotalModel {
  Year: number;
  Model: LocalCampaignStatisticsKpiModel[];
}

export class LocalCampaignStatisticsKpiModel {
  IdPvGroup: number;
  IdVnPlate: number;
  IdCampaignMedia: number;
  Mes: number;
  Total: number;
}

export class RenaultKpiExcelBriefingType1DTO{
  SectionName:string;
  Year: number;
  Month: string;
  PvGroupName: string;
  Data: KpiBriefingType1Model[];
}

export class RenaultKpiExcelBriefingType2DTO{
  SectionName:string;
  Year: number;
  Month: string;
  PvGroupName: string;
  Data: KpiBriefingType1Model[];
  Data2: KpiBriefingType1Model[];
}

export class KpiBriefingType1Model {
  KpiName: string;
  ShowComparativeRealizacion: boolean;
  Account_Month_Realizacion: number;
  Account_Month_Vs: number;
  Account_Month_Vs_class: string;
  Account_Acum_Realizacion: number;
  Account_Acum_Vs: number;
  Account_Acum_Vs_class: string;
  DR_Month_Realizacion: number;
  DR_Month_Vs: number;
  DR_Month_Vs_class: string;
  DR_Acum_Realizacion: number;
  DR_Acum_Vs: number;
  DR_Acum_Vs_class: string;
  Spain_Month_Realizacion: number;
  Spain_Month_Vs: number;
  Spain_Month_Vs_class: string;
  Spain_Acum_Realizacion: number;
  Spain_Acum_Vs: number;
  Spain_Acum_Vs_class: string;
  Top20_Month_Realizacion: number;
  Top20_Month_Vs: number;
  Top20_Month_Vs_class: string;
  Top20_Acum_Realizacion: number;
  Top20_Acum_Vs: number;
  Top20_Acum_Vs_class: string;
  MainSymbol:string;
  ComparativeSymbol:string;
  MainDecimals: number;
  ComparativeDecimals: number;
  IdKpiInfo: number;
  IdKpi: number;
  KpiType: KpiType;
}

export class CampaignCrmKpiTotalModel{
  Year: number;
  Model: CampaignCrmKpiModel[];
}

export class CampaignCrmKpiModel{
  Month: number;
  CrmData: RenaultReportTasasCrm[];
}

export class KpiRealizacionOneModel {
  Month: number;
  Year: number;
  Realizacion: number = 0;
  KpiName: string = 'N/D';
}

export class KpiRgShareModel {
  Month: number;
  Year: number;
  RgShareTotal: number;
  RgShareR1: number;
  RgShareR2: number;
  RgShareR3: number;
  RgShareTotalSpain: number;
  RgShareR1Spain: number;
  RgShareR2Spain: number;
  RgShareR3Spain: number;
  RgShareTotalTop15: number;
  RgShareR1Top15: number;
  RgShareR2Top15: number;
  RgShareR3Top15: number;
}

export class KpiRgShareCalcModel {
  RgShare: number;
  RgShareSpain: number;
  RgShareTop15: number;
}

export class RenaultKPIFilterHandler {
  KPI: string;
  Brand: number[];
  Payment: number[];
  WorkShop: number[];
  DistributorType: string[];
}

export class RenaultKPIMasterElement {
  Code: string;
  FilterControl: string;
}


export class KpiGroupsummaryModel {
  KpiName: string;
  Acumulado: number;
  VsA1: number;
  VsA1_Class: string;
  VsSpain: number;
  VsSpain_Class: string;
  VsTop10: number;
  VsTop10_Class: string;
  MainSymbol:string;
  ComparativeSymbol:string;
  MainDecimals: number;
  ComparativeDecimals: number;
  IdKpiInfo: number;
  IdKpi: number;
  KpiType: KpiType;
  LstAccount: KpiGroupsummaryAccountModel[];
}

export class KpiGroupsummaryAccountModel {
  Account: string;
  Acumulado: number;
  VsA1: number;
  VsA1_Class: string;
  VsSpain: number;
  VsSpain_Class: string;
  VsTop10: number;
  VsTop10_Class: string;
  ShowInSummary: boolean;
}
export class SectionPvGroupsummary {
  PvGroup: string;
  sectionPv: string;
  lstDistributors: number[];
  ShowInSummary: boolean;
}

export class DistributorGroupsummary {
  IdPvGroup: number;
  AccountParent: string;
  idDistributor: number;
  distributor: string;
  ShowInSummary: boolean;
}
